// eslint-disable-next-line import/no-cycle
import { adminApi } from '@/includes/contentManagementApi';

function serializeExportQuery(params) {
  const q = new URLSearchParams();
  if (params.startDate != null && params.startDate !== '') {
    const v = params.startDate instanceof Date ? params.startDate.toISOString() : params.startDate;
    q.set('startDate', v);
  }
  if (params.endDate != null && params.endDate !== '') {
    const v = params.endDate instanceof Date ? params.endDate.toISOString() : params.endDate;
    q.set('endDate', v);
  }
  if (params.categories) {
    const c = typeof params.categories === 'string'
      ? params.categories
      : params.categories.join(',');
    if (c) q.set('categories', c);
  }
  if (params.userQuery) {
    q.set('userQuery', params.userQuery);
  }
  return q.toString();
}

/**
 * NDJSON stream: { type: 'meta', totalEstimate }, batches, then { type: 'done', total }.
 * Uses fetch + ReadableStream (not axios) so the body is not fully buffered.
 */
function streamExport(params, onProgress) {
  const token = localStorage.getItem('jwt') || localStorage.getItem('token');
  const headers = { Accept: 'application/x-ndjson' };
  if (token) {
    headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  const qs = serializeExportQuery(params || {});
  const base = adminApi.defaults.baseURL || '';
  const url = `${base}/timeline/export-stream${qs ? `?${qs}` : ''}`;

  return (async () => {
    const res = await fetch(url, { headers });
    if (!res.ok) {
      let msg = res.statusText;
      try {
        const text = await res.text();
        try {
          const j = JSON.parse(text);
          msg = j.message || text || msg;
        } catch {
          msg = text || msg;
        }
      } catch {
        /* ignore */
      }
      throw new Error(msg || `Export failed (${res.status})`);
    }
    if (!res.body?.getReader) {
      throw new Error('Streaming is not supported in this browser');
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const events = [];
    let doneTotal = 0;
    let totalEstimate = 0;
    let exportCapped = false;

    const handleLine = (line) => {
      if (!line.trim()) return;
      const obj = JSON.parse(line);
      if (obj.type === 'meta' && typeof obj.totalEstimate === 'number') {
        totalEstimate = obj.totalEstimate;
        if (onProgress) {
          onProgress({
            loaded: events.length,
            totalEstimate,
            rowCap: obj.rowCap,
          });
        }
        return;
      }
      if (obj.type === 'batch' && Array.isArray(obj.events)) {
        events.push(...obj.events);
        if (onProgress) {
          onProgress({
            loaded: events.length,
            totalEstimate,
          });
        }
        return;
      }
      if (obj.type === 'done') {
        doneTotal = obj.total ?? events.length;
        exportCapped = Boolean(obj.capped);
      }
    };

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';
      lines.forEach(handleLine);
    }
    if (buffer.trim()) {
      handleLine(buffer);
    }
    return {
      events,
      total: doneTotal || events.length,
      totalEstimate,
      capped: exportCapped,
    };
  })();
}

export default {
  getEvents(params) {
    return adminApi.get('/timeline/events', { params });
  },
  getCategories() {
    return adminApi.get('/timeline/categories');
  },
  getStats(params) {
    return adminApi.get('/timeline/stats', { params });
  },
  streamExport,
};
